<div class="banco-santander-container">
  <div class="topo-relatorio">
    <div class="titulo-relatorio">Santander</div>
  </div>

  <div class="filtros-relatorio">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="alterarAno(-1)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="ano-pill">{{ ano }}</span>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="alterarAno(1)">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="saldo-inicial-group">
      <label>Saldo inicial</label>
      <input
        type="number"
        class="form-control form-control-sm"
        [(ngModel)]="saldoInicialPeriodo"
        (ngModelChange)="recalcularSaldo()" />
    </div>

    <button type="button" class="btn btn-primary btn-sm" (click)="carregarRelatorio()">
      <i class="fa fa-refresh"></i> Atualizar
    </button>
  </div>

  <div class="resumo-relatorio">
    <div class="resumo-box">
      <div class="resumo-label">Saldo inicial</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoInicialPeriodo || 0) }}</div>
    </div>
    <div class="resumo-box">
      <div class="resumo-label">Saldo atual</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoAtual) }}</div>
    </div>
    <div class="resumo-box">
      <div class="resumo-label">Sub-total créditos</div>
      <div class="resumo-valor">R$ {{ formatMoney(totalCreditos) }}</div>
    </div>
    <div class="resumo-box">
      <div class="resumo-label">Sub-total débitos</div>
      <div class="resumo-valor">R$ {{ formatMoney(totalDebitos) }}</div>
    </div>
  </div>

  <div class="card-box table-wrap">
    <table class="table table-bordered table-sm table-striped table-hover banco-santander-table">
      <thead>
        <tr>
          <th class="col-data sortable" (click)="ordenarPor('dataIso')">
            Data <i class="fa" [ngClass]="iconeOrdenacao('dataIso')"></i>
          </th>
          <th class="col-cod-cc sortable" (click)="ordenarPor('codCentroCusto')">
            Cód. CC <i class="fa" [ngClass]="iconeOrdenacao('codCentroCusto')"></i>
          </th>
          <th class="col-cc sortable" (click)="ordenarPor('centroCusto')">
            Centro de Custo <i class="fa" [ngClass]="iconeOrdenacao('centroCusto')"></i>
          </th>
          <th class="col-cod-pc sortable" (click)="ordenarPor('codPlanoContas')">
            Cód. PC <i class="fa" [ngClass]="iconeOrdenacao('codPlanoContas')"></i>
          </th>
          <th class="col-pc sortable" (click)="ordenarPor('descricaoPlanoContas')">
            Plano de Contas <i class="fa" [ngClass]="iconeOrdenacao('descricaoPlanoContas')"></i>
          </th>
          <th class="col-valor sortable" (click)="ordenarPor('credito')">
            Créditos <i class="fa" [ngClass]="iconeOrdenacao('credito')"></i>
          </th>
          <th class="col-valor sortable" (click)="ordenarPor('debito')">
            Débitos <i class="fa" [ngClass]="iconeOrdenacao('debito')"></i>
          </th>
          <th class="col-valor sortable" (click)="ordenarPor('saldo')">
            Saldo <i class="fa" [ngClass]="iconeOrdenacao('saldo')"></i>
          </th>
          <th class="col-info sortable" (click)="ordenarPor('informacoesAdicionais')">
            Inf. Adicionais <i class="fa" [ngClass]="iconeOrdenacao('informacoesAdicionais')"></i>
          </th>
          <th class="col-obs sortable" (click)="ordenarPor('observacao')">
            Observação <i class="fa" [ngClass]="iconeOrdenacao('observacao')"></i>
          </th>
          <th class="col-mes sortable" (click)="ordenarPor('mesPagamento')">
            Mês <i class="fa" [ngClass]="iconeOrdenacao('mesPagamento')"></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="11" class="text-center text-muted py-3">Carregando...</td>
        </tr>
        <tr *ngIf="!loading && !linhas.length">
          <td colspan="11" class="text-center text-muted py-3">
            Nenhum lançamento com banco Santander para {{ ano }}. Cadastre ou importe marcando o banco Santander.
          </td>
        </tr>
        <tr *ngFor="let linha of linhasPaginadas">
          <td class="col-data">{{ linha.dataExibicao }}</td>
          <td class="col-cod-cc">{{ linha.codCentroCusto || '-' }}</td>
          <td class="col-cc" [title]="linha.centroCusto">{{ linha.centroCusto || '-' }}</td>
          <td class="col-cod-pc">{{ linha.codPlanoContas || '-' }}</td>
          <td class="col-pc" [title]="linha.descricaoPlanoContas">{{ linha.descricaoPlanoContas || '-' }}</td>
          <td class="col-valor">{{ formatValorOuTraco(linha.credito) }}</td>
          <td class="col-valor">{{ formatValorOuTraco(linha.debito) }}</td>
          <td class="col-valor col-saldo">R$ {{ formatMoney(linha.saldo) }}</td>
          <td class="col-info" [title]="linha.informacoesAdicionais">{{ linha.informacoesAdicionais || '-' }}</td>
          <td class="col-obs" [title]="linha.observacao">{{ linha.observacao || '-' }}</td>
          <td class="col-mes">{{ linha.mesPagamento || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination-wrapper d-flex justify-content-between align-items-center mt-3" *ngIf="linhas.length > 0">
    <div class="d-flex align-items-center">
      <span class="me-2">Itens por página:</span>
      <select
        class="form-control form-control-sm"
        style="width: 90px;"
        [(ngModel)]="itensPorPagina"
        (change)="alterarItensPorPagina()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <span class="ms-3 text-muted">{{ linhas.length }} lançamento(s)</span>
    </div>

    <div class="text-muted">
      Página {{ paginaAtual }} de {{ totalPaginas || 1 }}
    </div>

    <div class="d-flex">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm me-2"
        (click)="paginaAnterior()"
        [disabled]="paginaAtual <= 1">
        Anterior
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="proximaPagina()"
        [disabled]="paginaAtual >= totalPaginas">
        Próxima
      </button>
    </div>
  </div>
</div>
